import { render } from "./EmployeeViewLiquidation.vue?vue&type=template&id=067b9d8b"
import script from "./EmployeeViewLiquidation.vue?vue&type=script&lang=js"
export * from "./EmployeeViewLiquidation.vue?vue&type=script&lang=js"

import "./EmployeeViewLiquidation.vue?vue&type=style&index=0&id=067b9d8b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__